import { combineReducers } from "redux";
import { applicationsState } from "./applicationsReducer";

export const applicationsReducers = combineReducers({
    applicationsState: applicationsState
});
